import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import MFooter from './MFooter';
import MHeader from './MHeader';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../withRouterCompat';
import {Helmet} from 'react-helmet-async';

const MOBILE_NAV_MAX_WIDTH = 991;
const SKIP_LINK_ID = 'skip-to-main';

class PageBase extends React.Component{
  isMobileSearchTrap(){
    const searchTab = helpers.getById(this.props.mHeaderTab, 'search');
    if(!searchTab || !searchTab.isOpen) return false;
    return typeof window !== 'undefined' && window.innerWidth <= MOBILE_NAV_MAX_WIDTH;
  }
  isMobileHamburgerTrap(){
    if(!this.props.mHeader?.isOpen) return false;
    if(this.isMobileSearchTrap()) return false;
    return typeof window !== 'undefined' && window.innerWidth <= MOBILE_NAV_MAX_WIDTH;
  }
  syncSkipLinkInert(trapPageContent){
    if(typeof document === 'undefined') return;
    const skipLink = document.getElementById(SKIP_LINK_ID);
    if(!skipLink) return;
    if(trapPageContent){
      skipLink.setAttribute('inert', '');
    }
    else{
      skipLink.removeAttribute('inert');
    }
  }
  ensureSkipLinkFirst(){
    if(typeof document === 'undefined') return;
    const skipLink = document.getElementById(SKIP_LINK_ID);
    if(skipLink?.parentNode){
      skipLink.parentNode.insertBefore(skipLink, skipLink.parentNode.firstChild);
    }
  }
  componentDidMount(){
    this.ensureSkipLinkFirst();
    this.syncSkipLinkInert(this.isMobileSearchTrap() || this.isMobileHamburgerTrap());
  }
  componentDidUpdate(){
    this.syncSkipLinkInert(this.isMobileSearchTrap() || this.isMobileHamburgerTrap());
  }
  componentWillUnmount(){
    this.syncSkipLinkInert(false);
  }

  render(){
    // console.log(`PageBase.render()`, this.props);

    const hamburgerOpenClass = this.props.mHeader && this.props.mHeader.isOpen ? 'page--hamburger-is-open' : '';
    const mobileSearchTrap = this.isMobileSearchTrap();
    const mobileHamburgerTrap = this.isMobileHamburgerTrap();
    const searchOpenClass = mobileSearchTrap ? 'page--search-is-open' : '';
    const trapPageContent = mobileSearchTrap || mobileHamburgerTrap;
    const contentTitle = apiValues.pageTitleWithoutSiteSuffix(document.title);

    return (
      <div className={`page ${this.props.className || ''} ${hamburgerOpenClass} ${searchOpenClass}`}>
        <Helmet>
          <meta property="og:site_name" content={apiValues.OG_SITE_NAME}/>
          <meta property="og:url" content={`${window.location.protocol}//${window.location.host}${window.location.pathname}`}/>
          <meta property="og:title" content={contentTitle}/>
          {this.props.mHeader && this.props.mHeader.imageLogo && (<meta property="og:image" content={this.props.mHeader.imageLogo.url}/>)}
          <meta name="twitter:card" content="summary"/>
          <meta name="twitter:image:alt" content={apiValues.OG_SITE_NAME}/>
        </Helmet>
        <div className="page__sticky">
          <MHeader className="coupling coupling--full-max"/>
          <main id="main"
                className="page__sticky-body"
                {...(trapPageContent ? {inert: ''} : {})}>
            {this.props.children}
          </main>
          <div className="page__footer-region"
               {...(trapPageContent ? {inert: ''} : {})}>
            <MFooter className="coupling coupling--full-centered"/>
          </div>
        </div>
      </div>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    mHeader: state.mHeader,
    mHeaderTab: state.mHeaderTab,
  }),
)(PageBase));


PageBase.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  mHeader: PropTypes.object,
  mHeaderTab: PropTypes.array,
};
